import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { Container } from "components/Container";
import { Grid } from "modules/common/components/Grid";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { HeroProps } from "./Hero.d";
import { linkStyles, textStyles } from "./Hero.styles";
import { STORYBLOK_ASSET_MANAGER_URL, getStoryblokAsset, optimiseStoryblokImage } from "../../utils";

const Hero = ({ heading, subHeading, text, link, heroImage }: HeroProps) => (
  <>
    <Grid mb={{ base: 12, lg: 24 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <Flex flexDir="column" align={{ base: "flex-start", lg: "center" }}>
          {subHeading && (
            <Text
              color="primary.500"
              fontSize="sm"
              mb={2}
              textTransform="uppercase"
              fontWeight="bold"
              letterSpacing="wide"
            >
              {subHeading}
            </Text>
          )}
          {heading && (
            <Heading variant="h1" as="h1" mb={6}>
              {heading}
            </Heading>
          )}
          <RichtextAdapter content={text} customStyles={textStyles} />
          {link && <RichtextAdapter content={link} customStyles={linkStyles} />}
        </Flex>
      </Box>
    </Grid>
    <Box bgGradient="linear(to-b, greyscale.100 50%, greyscale.300 0)">
      <Container px={{ base: 4, xl: "unset" }} pos="relative">
        <Image
          src={`${STORYBLOK_ASSET_MANAGER_URL}/f/108829/154x120/9be96bd985/airhelp-score-logo-decoration-desktop.svg`}
          pos="absolute"
          top={0}
          left={{ base: "10%", md: "7%", lg: "5%" }}
          w={{ base: "124px", lg: "154px" }}
        />
        <Image
          borderRadius="md"
          minW="100%"
          src={optimiseStoryblokImage(getStoryblokAsset(heroImage).assetSource)}
          alt={getStoryblokAsset(heroImage).assetAlt}
        />
      </Container>
    </Box>
  </>
);

export default Hero;
